<template>
  <div>
    <Head :title="`${$t('situationcases.situation_case')} #${form.id}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_details.id}/view`">
        {{ data.applicant_details.name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_details.id}/situation-cases/${data.id}/view`">
        {{ data.id }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ $t('global.update') }}
    </h1>
    <trashed-message v-if="data.deleted_at" class="mb-6" @restore="restore">
      {{ $t('situationcases.trashed_message') }}
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <Form :form-data="form" :locations="locations" />
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            v-if="!data.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
            @click="destroy"
          >
            {{ $t('global.delete') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ $t('global.update') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    data: Object,
    locations: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        'id': this.data.id,
        'location_id': this.data.location_id,
        'date_imprisonment': this.data.date_imprisonment,
        'reason_imprisonment': this.data.reason_imprisonment,
        'interned': !!this.data.interned,
        'deleted_at': this.data.deleted_at,

      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/applicants/${this.data.applicant_id}/situation-cases/${this.data.id}`)
    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/applicants/${this.data.applicant_id}/situation-cases/${this.data.id}`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/situation-cases/${this.data.id}/restore`)
        }
      })
    },
  },
}
</script>
